/**
 * Trade Book Page
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTradeBook } from '../redux/slices/orderSlice';

const TradeBook = () => {
  const dispatch = useDispatch();
  const { tradeBook } = useSelector((state) => state.orders);

  useEffect(() => {
    dispatch(fetchTradeBook());
  }, [dispatch]);

  // Debug: Log trade book data to see what fields are available
  useEffect(() => {
    if (tradeBook && tradeBook.length > 0) {
      console.log('TradeBook Data Sample:', tradeBook[0]);
      console.log('All fields:', Object.keys(tradeBook[0]));
    }
  }, [tradeBook]);

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-gray-800">Trade Book</h1>

      <div className="card">
        {tradeBook.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="table-auto w-full text-sm">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Exchange</th>
                  <th>Trading Symbol</th>
                  
                  <th>Order Type</th>
                  <th>Qty</th>
                  <th>Traded Price</th>
                </tr>
              </thead>
              <tbody>
                {tradeBook.map((trade, idx) => {
                  // Use formattedInstrumentName for display, fallback to tradingSymbol
                  const displaySymbol = trade.formattedInstrumentName || trade.tradingSymbol || '-';
                  
                  return (
                    <tr key={idx}>
                      <td className="text-xs whitespace-nowrap">{trade.fillTimestamp || '-'}</td>
                     <td className="text-xs font-semibold">{trade.exchange || '-'}</td>
                      <td className="font-medium">
                        {displaySymbol}
                      </td>
                      
                      <td className={trade.transactionType === 'BUY' ? 'text-green-600 font-semibold' : 'text-red-600 font-semibold'}>
                        {trade.transactionType || '-'}
                      </td>
                      <td className="text-right">{trade.filledQuantity || '-'}</td>
                      <td className="text-right font-medium">₹{trade.tradedPrice || '0.00'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center py-8 text-gray-500">No trades executed today</p>
        )}
      </div>
    </div>
  );
};

export default TradeBook;
